<template>
    <div id="main-modal">
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t('detalhes-ocorrencia') }}
                </h1>
            </div>
            <div class="header-buttons">
                <button class="delete-btn" type="button" @click="onFecharModal">
                    {{ $t('cancelar') }}
                </button>
            </div>
        </div>

        <div v-if="showTabs">
            <ul
                class="nav nav-tabs nav-tabs-children"
                v-if="ocorrenciaHasAnexos || ocorrenciaHasProdutos"
            >
                <li
                    v-for="(aba, i) in abas"
                    :key="i"
                    :class="{ active: abaSelecionada == i }"
                    @click="changeTab(i)"
                >
                    <a data-toggle="tab">{{ $t(aba) }}</a>
                </li>
            </ul>

            <!-- CONJTO DE ABAS - MOBILE -->
            <b-dropdown
                aria-role="list"
                class="mobile-tab-list"
                v-if="ocorrenciaHasAnexos || ocorrenciaHasProdutos"
            >
                <div slot="trigger" class="mobile-tab">
                    <span class="mobile-tab-text">
                        {{ abas[abaSelecionada] ? $t(abas[abaSelecionada]) : '' }}
                    </span>
                    <em class="mdi mdi-chevron-down"></em>
                </div>

                <b-dropdown-item
                    class="mobile-tab-list-item"
                    :class="{ active: abaSelecionada == i }"
                    aria-role="listitem"
                    v-for="(aba, i) in abas"
                    :key="i"
                    @click="changeTab(i)"
                >
                    {{ $t(aba) }}
                </b-dropdown-item>
            </b-dropdown>

            <div class="aba-detalheocorrencia">
                <Geral
                    ref="tabGeral"
                    v-if="abasAbertas['geral'] && permissaoDetalheOcorrencias.read"
                    v-show="abaSelecionada == 0"
                    :idagro_ocorrencia="+ocorrenciaId"
                />

                <ProdutosOcorrencia
                    ref="tabGeral2"
                    v-if="
                        abasAbertas['produtos-ocorrencia'] &&
                        permissaoDetalheOcorrencias.read &&
                        ocorrenciaHasProdutos
                    "
                    v-show="ocorrenciaHasProdutos && abaSelecionada == 1"
                    :idagro_ocorrencia="+ocorrenciaId"
                />

                <AnexosOcorrencia
                    ref="tabGeral3"
                    v-if="
                        abasAbertas['anexos-ocorrencia'] &&
                        permissaoDetalheOcorrencias.read &&
                        ocorrenciaHasAnexos
                    "
                    v-show="ocorrenciaHasAnexos && showAnexo()"
                    :idagro_ocorrencia="+ocorrenciaId"
                />
            </div>
        </div>
    </div>
</template>

<script>
// Abas
import Geral from '@/components/agro/agro-visita-item/abas/detalhes-ocorrencia/Geral';
import AnexosOcorrencia from '@/components/agro/agro-visita-item/abas/detalhes-ocorrencia/AnexosOcorrencia';
import ProdutosOcorrencia from '@/components/agro/agro-visita-item/abas/detalhes-ocorrencia/ProdutosOcorrencia';

export default {
    components: {
        Geral,
        AnexosOcorrencia,
        ProdutosOcorrencia,
    },
    props: {
        abaSelecionadaNome: {
            type: String,
            default: 'geral',
        },
        ocorrenciaId: 0,
        ocorrenciaHasAnexos: {
            type: Boolean,
            default: false,
        },
        ocorrenciaHasProdutos: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            id: 0,
            abaSelecionada: 0,
            // Seguir nome na tabela app_tela e usar estes nomes no dicionário para criação dinâmica de listaPermissoes e abasAbertas
            abas: ['geral'],
            abasAbertas: {},
            permissaoDetalheOcorrencias: false,
            showTabs: false,
        };
    },
    mounted() {
        if (this.abaSelecionadaNome && this.abaSelecionadaNome != 'geral') {
            this.abaSelecionada = this.abas.indexOf(this.abaSelecionadaNome);
            this.changeTab(this.abaSelecionada);
        }
    },
    created() {
        this.permissaoDetalheOcorrencias = this.hasPermissionAccess(
            'agro',
            'agro-cadastros',
            'agro-ocorrencia'
        );

        if (!this.permissaoDetalheOcorrencias.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'detalhes-ocorrencia' },
            });
        } else {
            if (this.ocorrenciaHasProdutos) {
                this.abas.push('produtos-ocorrencia');
            }

            if (this.ocorrenciaHasAnexos) {
                this.abas.push('anexos-ocorrencia');
            }

            this.showTabs = true;

            this.abasAbertas['geral'] = true;
        }
    },
    methods: {
        showAnexo() {
            let abaKey = this.ocorrenciaHasProdutos ? 2 : 1;
            return +this.abaSelecionada == abaKey;
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;
        },
        onFecharModal() {
            this.$emit('fecharModal', true);
        },
    },
};
</script>

<style lang="scss" scoped>
#main-modal {
    padding: 20px 20px;
}

@media only screen and (max-width: 760px) {
    .nav.nav-tabs-main {
        display: flex;
        justify-content: center;
        padding: 0;
        margin: 0;

        &::after {
            display: none;
        }
    }

    .nav.nav-tabs.nav-tabs-children {
        display: none;
    }
}

@media only screen and (min-width: 761px) {
    .mobile-tab-list {
        display: none;
    }
}
</style>
